export default "__VITE_ASSET__901ca426__"